import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Roles } from 'app/auth';
import config from '../../config.json';

const ukDefaultRouteByRole = {
  [Roles.SUPPORT]: 'command-centre',
  [Roles.PHARMACIST]: 'command-centre',
  [Roles.PHARMACY_ADMIN]: 'command-centre',
  [Roles.PRESCRIBER]: 'prescribing',
};

const canadaDefaultRouteByRole = {
  [Roles.SUPPORT]: 'patients',
  [Roles.PHARMACIST]: 'patients',
  [Roles.PHARMACY_ADMIN]: 'patients',
  [Roles.PRESCRIBER]: 'prescribing',
};

const defaultRouteByRole =
  config.deploymentRegion === 'canada' ? canadaDefaultRouteByRole : ukDefaultRouteByRole;

export function useHomePage() {
  const navigate = useNavigate();

  const auth = useSelector((state) => state.auth);
  const userIsLoggedIn = Boolean(auth?.user?._id);

  const useRole = auth.user.roles[0];
  const userPreferredHomePage = auth.user.preferences?.connect_home_page;
  const homeRoute = userPreferredHomePage || defaultRouteByRole[useRole] || 'patients';

  useEffect(() => {
    if (userIsLoggedIn) {
      navigate(homeRoute, { replace: true });
      return;
    }

    navigate('login', { replace: true });
  }, [navigate, userIsLoggedIn, homeRoute]);
}

export function HomePageComponent() {
  useHomePage();
}

export default {};
